import randomId from 'random-id';
import { stripeConnectRef, stripeConnectType } from './consts';

export default function(editor, opts = {}) {
  const options = opts;
  const bm = editor.BlockManager;
  const pfx = options.pfx;
  const stripeBuyBtnId = 'stripe-buy-item' + randomId(8, '');

  if (options.blocks.indexOf(stripeConnectRef) >= 0) {
    bm.add(stripeConnectRef, {
      label: `
      <i class="webconnect-cart-check"></i><div>${options.labelStripeConnectBuy}</div>
     `,
      category: options.labelStripeConnectBuyCategory,
      content: `
        <button id="${stripeBuyBtnId}" class="${pfx} btn btn-outline-primary btn-sm mx-2"
        data-gjs-type="${stripeConnectType}"
        data-gjs="${stripeConnectType}"
        data-gjs-custom-name="${options.labelStripeConnectBuy}">Buy now</button>
      `,
      render: ({ model, className }) => `
      <div class="${className}-label ${className}__drapcode-wrap">
      ${model.get('label')}
      </div>

      <span class="${className}__info no-doc">
        <a target="_blank" href="#" draggable="false">
          <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
        options.labelStripeConnectBuy
      }?"></i>
        </a>
      </span>
    `,
    });
  }
}
